import api from './axios'

class ServiceResponsible {
  async save(responsible) {
    const { data } = await api.post(`/responsible`, responsible);
    return data
  }

  async update(responsible, id) {
    const { data } = await api.put(`/responsible/${id}`, responsible);
    return data
  }

  async getResponsibleForSelectBox(selectedId) {
    const { data } = await api.get('/responsible/combobox', {
      params: { selectedId }
    })
    return data
  }

  async findAll() {
    const { data } = await api.get('/responsible')
    return data
  }

  async findById(id) {
    const { data } = await api.get(`/responsible/${id}`);
    return data
  }

  async delete(id) {
    await api.delete(`/responsible/${id}`);
  }

  async uploadCert(id, payload) {
    await api.post(`/responsible/upload-cert/${id}`, payload);
  }

  async removeCert(id) {
    await api.delete(`/responsible/${id}/cert`);
  }
}

export default new ServiceResponsible
